import React, { Component } from "react";
import classnames from "classnames";
import Paper from "@material-ui/core/Paper";
import { withTranslation, Trans } from "react-i18next";
import Grid from "@material-ui/core/Grid";
import Card from '@material-ui/core/Card';
import Button from "@material-ui/core/Button";
import FormGroup from "@material-ui/core/FormGroup";
import Input from "@material-ui/core/Input";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import LockOpenIcon from "@material-ui/icons/LockOpen";
import FormControl from "@material-ui/core/FormControl";
import imgUrl from "../../assets/images/imageUrl.js";
import Loader from "../loaders/loader";
import { connect } from "react-redux";
import { useHistory, withRouter, Route, Redirect, Switch, Link } from "react-router-dom";
import { withStyles, makeStyles, useTheme, withTheme } from "@material-ui/core/styles";
import { signup, signin, logout, signInAnonymously } from "../../helpers/auth";
import { auth } from "../../service/firebase";
import { db, storageRef } from "../../service/firebase";
import ApiServices from "../../api/api";
import TextField from "@material-ui/core/TextField";
import Services from "../../api/api";
import swal from "sweetalert";
import OffileDb from '../../config/pouchDB';
import { gaLogEvent } from "../../helpers/analytics";


class LoginPin extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: true,
      userDetails: [],
      name: '',
      password: '',
      passwordVisibility1: false,
      passwordVisibility2:false,
      fieldvisible: false,
      pin: ''
    };
    this.handleChangeName = this.handleChangeName.bind(this);
    this.handleChangePassword = this.handleChangePassword.bind(this);
    this.handleChangePin = this.handleChangePin.bind(this);
    this.getUserDeatils = this.getUserDeatils.bind(this);
    this.toggleVisibility = this.toggleVisibility.bind(this);
  }

  componentDidMount() {
    gaLogEvent("Settings User Login", '', '');
    if (localStorage) { // fix for API
      localStorage.removeItem("firebase:previous_websocket_failure");
  }
    let loginattempted = localStorage.getItem('loginattempted');
    console.log("loginattempted",loginattempted)
    this.setState({
      fieldvisible:loginattempted
    });    
    OffileDb.setDatabase()
  }

  handleChangeName(event) {
    // console.log(event)
    this.setState({
      name: event.target.value,
    });
  }
  handleChangePin(event) {
    // console.log(event)
    this.setState({
      pin: event.target.value,
    });
  }
  handleChangePassword(event) {
    // console.log(event)
    this.setState({
      password: event.target.value,
    });
  }

  handleSubmit = (event) => {
    var self = this;
    event.preventDefault();
    const { t } = this.props;
    this.setState({ isLoading: true });
    const re = /^[0-9\b]+$/;
    var param = {
      userName: localStorage.getItem('loggedinuser'),
      password: localStorage.getItem('loggedinpass'),
      pin: this.state.pin,
      communityId: ''
    };

    console.log("login param:", param)

    //check if pin has not been expired
    var userParam = {
      userName: localStorage.getItem('loggedinuser')
    }
    Services.IdentifyUserType(userParam).then((res) => {
      console.log("IdentifyUserType res::", res)
      if(res.data && res.data.data){
        if(res.data.data.pinExpired == true){
          // show alert that pin has been expired
          self.props.history.push("/layout/resetPin");
        }else{
          if (re.test(param.pin)) { 
          if (param.userName != "" && param.password != "" && param.pin != "") {
            if(param.pin.length==4 ){
            Services.dashboardLogin(param).then((res) => {
              try {
                if (res.data.status == 200) {
                  OffileDb.deleteDatabse();
                  setTimeout(function () {
                    localStorage.setItem('tempuserobj', localStorage.getItem('obj'))
                    localStorage.setItem('adminobj', JSON.stringify({
                      roleId: res.data.data.roleId,
                      roleType: res.data.data.masterRoleType.roleType,
                      userId: res.data.data.userId,
                      userType: res.data.data.userType,
                      communityId: res.data.data.communityId
                    }))
                    localStorage.setItem('obj', JSON.stringify({
                      roleId: res.data.data.roleId,
                      roleType: res.data.data.masterRoleType.roleType,
                      userId: res.data.data.userId,
                      userType: res.data.data.userType,
                      communityId: res.data.data.communityId
                    }))
                    self.getUserDeatils(res.data.data.userId)
                  }, 500);
                  localStorage.setItem('loggedinname', localStorage.getItem('loggedinuser'));
                }
              } catch (err) {
                console.log("Error::", err);
              }
            });
          } else {
            swal({
              title: t("Pin length incorrect.Please enter a pin of length 4"),
              icon: "warning",
              button: t("Ok"),
            })
          }
          } else {
            swal({
              title: t("Please enter correct pin"),
              icon: "warning",
              button: t("Ok"),
            })
          }
          }else{
            swal({
              title: t("Only numeric pin allowed"),
              icon: "warning",
              button: t("Ok"),
            })
          }
        }
      }
    })


  };

  getUserDeatils(userId) {
    var param = {
      "communityId": this.props.communityuid,
      "userId": userId
    }
    ApiServices.getUserProfile(param).then((res) => {
      if (res.status == 200) {
        if(res.data.data){
          var loggedinnameonly = localStorage.getItem("loggedinname");
      var loggedinname = localStorage.getItem("loggedinname");
      if(loggedinname){
        // create a valid email for firebase login if user is using id
        if(loggedinname.indexOf('@') == -1){
          loggedinname = loggedinname + '@myrights.com';
          if(loggedinname.indexOf(' ') != -1){
            loggedinname = loggedinname.split(' ').join('_');
          }
        }
        signup(loggedinname, localStorage.getItem("loggedinpass"))
          .then((userCredential) => {
            console.log("userCredential", userCredential)
            // Signed in 
            var user = userCredential.user;
            user.updateProfile({
              displayName: loggedinnameonly,
            })
            // ...
          })
          .catch((error) => {
            console.log("error", error)
            signin(loggedinname, localStorage.getItem("loggedinpass"))
              .then((userCredential) => {
                console.log("userCredential", userCredential)
                // Signed in 
                var user = userCredential.user;
                user.updateProfile({
                  displayName: loggedinnameonly,
                })
                // ...
              })
              .catch((error) => {
                console.log("error", error)
                var errorCode = error.code;
                var errorMessage = error.message;
                // ..
              });
          });
      }else{
        signInAnonymously().then((res) => {
          auth().onAuthStateChanged((user) => {
            console.log("onAuthStateChanged>>", user);
            if (user) {
            } else {
              console.log("error>>", user);
            }
          });
        })
          .catch((err) => console.log("err>>>", err));
      }
          // signInAnonymously().then((s) => {
          //   auth().onAuthStateChanged((user) => {
          //     if (user) {
          //       user.updateProfile({
          //         displayName: res.data.data.profile.nickName,
          //       }).then(function (s) {
          //           console.log("updateProfile res>>", s);
          //         }).catch(function (error) {
          //           console.log("updateProfile error>>", error);
          //         });
          //     }
          //   });
          // }).catch((err) => console.log("err>>>", err));
        }
      }
      localStorage.removeItem("loginattempted");
      this.props.history.push("/layout");
    });
  }

  toggleVisibility(number) {
    if(number==1){
      this.setState({
        passwordVisibility1: !this.state.passwordVisibility1
      })
    }else{
      this.setState({
        passwordVisibility2: !this.state.passwordVisibility2
      })
    }
    
  }

  render() {
    const { t } = this.props;
    const { templateID } = this.props;
    return (
      <div className="gk-page getknowledgeable_page">

        {
          templateID == 1 && (
            <div className="backgroundivholder">
              <div className="bgdiv1">
                <div className="welcometopcurve">
                  <svg data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 120" preserveAspectRatio="none">
                    <path d="M600,112.77C268.63,112.77,0,65.52,0,7.23V120H1200V7.23C1200,65.52,931.37,112.77,600,112.77Z" className="shape-fill"></path>
                  </svg>
                </div>
              </div>
              <div className="bgdiv2"></div>

            </div>
          )
        }

        <form
          id="chat-profile"
          onSubmit={this.handleSubmit}
        >
          <Grid container spacing={3} className="gridcontainer">
          {this.state.fieldvisible ? 
          (<Grid item xs={12} className="profileformholder bgcolorOfCard">
              <p className="chatusername">{t("Enter username")}</p>
              <TextField
                id="standard-helperText"
                // label={t("Enter username")}
                disabled
                value = {localStorage.getItem('loggedinuser')}
                onChange={this.handleChangeName}
                onBlur={this.handleExistUser}
              />
            </Grid>):("")}

            {this.state.fieldvisible ? 
            (<Grid item xs={12} className="profileformholder bgcolorOfCard">
              <p className="chatusername">{t("Enter password")}</p>
              <div style={{'display':'flex'}}>
              <TextField
                id="standard-helperText"
                disabled
                value = {localStorage.getItem('loggedinpass')}
                // label={t("Enter password")}
                type={this.state.passwordVisibility1 ? "text" : "password"}
                onChange={this.handleChangePassword}
              />
              <Button className="toggle-pw-visibility2"
                    id="toggle-pw-visibility"
                    onClick={()=>this.toggleVisibility(1)}
                    style={this.state.passwordVisibility1 ? {} : { textDecoration: "line-through" }}
                  >
                    👁
              </Button>
              </div>
            </Grid>):("")}
            

            <Grid item xs={12} className="profileformholder bgcolorOfCard">
              <p className="chatusername">{t("Enter your pin to continue")}</p>
              <TextField
                id="standard-helperText"
                type={this.state.passwordVisibility2? "number" : "password"}
                // label={t("Enter your pin to continue")}
                onChange={this.handleChangePin}
              />
              <Button className={this.state.fieldvisible?"toggle-pw-visibility3":"toggle-pw-visibility1"}
                    id="toggle-pw-visibility"
                    onClick={()=>this.toggleVisibility(2)}
                    style={this.state.passwordVisibility2 ? {} : { textDecoration: "line-through" }}
                  >
                    👁
              </Button>
            </Grid>
            <Grid item xs={12} className="profileformholder">
              <div className="text-center">
                <Button
                  type="submit"
                  variant="contained"
                  color="primary"
                  disableElevation
                  className="profilesubmitbtn"
                >
                  {t('Continue')}
                </Button>
              </div>
            </Grid>
          </Grid>
        </form>
      </div>
    );
  }
}


const mapStateToProps = (state) => {
  let { storeState } = state;
  return {
    templateID: JSON.parse(localStorage.getItem('templateID')) != null ? JSON.parse(localStorage.getItem('templateID')) : storeState.templateID,
    communityuid: storeState.communityId,
    langId: storeState.langId,
    selectedComponentObj: storeState.componentObj,
  };
};

const transLoginPin = withTranslation()(LoginPin);
const themeLoginPin = withTheme(transLoginPin);
const routeLoginPin = withRouter(themeLoginPin);
export default connect(mapStateToProps, {})(routeLoginPin);
